import { AppBar, Toolbar, Typography, Button, Box, Container } from '@mui/material';
import { Link } from 'react-router-dom';

const Navbar = () => {
    return (
        <AppBar
            position="static"
            elevation={0}
            sx={{
                backgroundColor: '#ffffff',
                borderBottom: '1px solid #e0e0e0',
                color: '#333',
            }}
        >
            <Container maxWidth="lg">
                <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>
                    {/* Logo */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography
                            variant="h5"
                            component={Link}
                            to="/"
                            sx={{
                                fontWeight: 'bold',
                                color: 'secondary.main',
                                textDecoration: 'none',
                                '&:hover': {
                                    textDecoration: 'none',
                                },
                            }}
                        >
                            Puppet Interview
                        </Typography>
                    </Box>

                    {/* Navigation Links */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                        <Button
                            color="inherit"
                            component="a"
                            href="https://puppetinterview.com"
                            sx={{
                                color: '#666',
                                textTransform: 'none',
                                fontSize: '1rem',
                                '&:hover': {
                                    color: 'primary.main',
                                    backgroundColor: 'transparent',
                                },
                            }}
                        >
                            About
                        </Button>
                        <Button
                            color="inherit"
                            component="a"
                            href="https://puppetinterview.com"
                            sx={{
                                color: '#666',
                                textTransform: 'none',
                                fontSize: '1rem',
                                '&:hover': {
                                    color: 'primary.main',
                                    backgroundColor: 'transparent',
                                },
                            }}
                        >
                            How It Works
                        </Button>
                        <Button
                            color="inherit"
                            component="a"
                            href="https://puppetinterview.com"
                            sx={{
                                color: '#666',
                                textTransform: 'none',
                                fontSize: '1rem',
                                '&:hover': {
                                    color: 'primary.main',
                                    backgroundColor: 'transparent',
                                },
                            }}
                        >
                            Pricing
                        </Button>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Navbar;
